// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
  .no-data-message {
    display: inherit;
    transform: translate(-50%, -50%);
    position: absolute;
    top: 50%;
    left: 50%;
    font-weight: bold;
    font-size: 12px;
    color: #a9a9a9;
    white-space: pre;
  }
`, "",{"version":3,"sources":["webpack://./src/app/components/ag-plot/ag-plot.ts"],"names":[],"mappings":";EACE;IACE,gBAAgB;IAChB,gCAAgC;IAChC,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB","sourcesContent":["\n  .no-data-message {\n    display: inherit;\n    transform: translate(-50%, -50%);\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    font-weight: bold;\n    font-size: 12px;\n    color: #a9a9a9;\n    white-space: pre;\n  }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
